import { render, staticRenderFns } from "./pos-Expenses.vue?vue&type=template&id=25d69a99"
import script from "./pos-Expenses.vue?vue&type=script&lang=js"
export * from "./pos-Expenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports